import React from "react";
import { Label, Input } from "reactstrap";
import DOCUMENT_TYPES from "../Types";

const FileUploadTab = ({
  file,
  onFileChange,
  documentType,
  onDocumentTypeChange,
  description,
  onDescriptionChange,
}) => {
  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    onFileChange(selectedFile || null);
  };

  return (
    <div>
      <div className="mb-3">
        <Label for="documentFile">File</Label>
        <Input type="file" id="documentFile" onChange={handleFileChange} />
      </div>
      <div>
        <Label for="documentType">Document Type</Label>
        <Input
          type="select"
          id="documentType"
          value={documentType}
          onChange={(e) => onDocumentTypeChange(e.target.value)}
        >
          {DOCUMENT_TYPES.map((type) => (
            <option key={type.value} value={type.value}>
              {type.label}
            </option>
          ))}
        </Input>
      </div>
      <div>
        <Label for="documentDescription">Description</Label>
        <Input
          type="textarea"
          id="documentDescription"
          value={description}
          onChange={(e) => onDescriptionChange(e.target.value)}
          placeholder="Optional document description"
        />
      </div>
    </div>
  );
};

export default FileUploadTab;
